import React, { useState } from "react";
import "./dropdown.css";
import { Select } from "antd";
import {
  BlueArrowDown,
  DoubbleBlueArrowDown,
} from "../../assets/InterBranch/SVGIcons/icons";
import { PulseLoader } from "react-spinners";
const { Option } = Select;

function Dropdown({
  width,
  data,
  placeholder,
  isV2,
  value,
  onChange,
  options,
  id,
  name,
  index,
  loading,
  haveStatus,
  showSearch,
  disabled,
  defaultValue,
}) {
  let [dummy, setDummy] = useState(value);

  console.log("dop down values ",value,data ,defaultValue)

  function handleChange(value) {
    console.log(`selected ${value}`);
  }

  const getIcon = () => {
    if (loading) {
      return <PulseLoader color="#0a8ce0" size={6} />;
    } else if (isV2) {
      return <DoubbleBlueArrowDown />;
    } else {
      return <BlueArrowDown />;
    }
  };

  return (
    <Select
      defaultValue={defaultValue || null}
      disabled={disabled || false}
      showSearch={showSearch}
      id
      name
      loading
      getPopupContainer={(trigger) => trigger.parentNode}
      onChange={
        onChange
          ? (value, event, e) => {
              onChange(value, id, name, index);
            }
          : (e) => {
              setDummy(e);
            }
      }
      placeholder={placeholder ? placeholder : null}
      suffixIcon={getIcon()}
      value={value}
      className="c-dropdown"
      style={{ width: width ? width : 230 }}
    >
      {data ? (
        data.map((element, key) => {
          return (
            <Option
              key={key}
              value={element.value}
              style={{ whiteSpace: "nowrap" }}
              title={element.option}
            >
              <div
                style={{
                  whiteSpace: "nowrap",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                {element && haveStatus && (
                  <StatusIndicator
                    status={element.status ? element.status : false}
                  />
                )}
                {element.option}
              </div>
            </Option>
          );
        })
      ) : (
        <Option value="No Data">No Data Available</Option>
      )}
    </Select>
  );
}

export default Dropdown;

const StatusIndicator = ({ status }) => {
  return (
    <div
      className={`interbranch-dr-status-icon ${
        status == "Active" ? "dr-status-icon-active" : "dr-status-icon-inactive"
      }`}
    ></div>
  );
};
